import MaxLengthNumericEditor from '../../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../../SharedModules/StyleConstant/StyleConstant';
export const PLAN_TYPE_DATA = [
  { name: 'Medicaid', value: 'FD' },
  { name: 'Commercial', value: 'COMM' },
  { name: 'State', value: 'ST' },
  { name: 'Supplemental', value: 'SUPP' },
];
export const PLAN_TYPE_DATA_CAL_INS = [
  { name: 'Medicaid', value: 'FD' },
  { name: 'Commercial', value: 'COMM' },
  { name: 'State', value: 'ST' },
  { name: 'Supplemental', value: 'SUPP' },
];
export const textFieldLabelFrom = 'Start Date';
export const textFieldLabelTo = 'End Date';
export const SELECTED_BY_OPTIONS = [
  { name: 'Ineligible Provider', value: 'INELEGPRO' },
  { name: 'NDC', value: 'NDC' },
  { name: 'Drug Family', value: 'DRUGFAMILY' },
  { name: 'Special Circumstances', value: 'SPCIR' },
];
export const CHOOSE_BY_OPTIONS = [
  { name: 'NDC', value: 'NDC' },
  { name: 'Manufacturer', value: 'MANUFACTURER' },
];
export const ACTIONS_OPTIONS = [
  { name: 'Invoice', value: 'INVOICE' },
  { name: 'Uninvoice', value: 'UNINVOICE' },
];
export const NDC_TABS_DATA = [
  { name: 'NDC', value: 'ndc' },
  { name: 'Name', value: 'name' },
  { name: 'Labeler', value: 'labeler' },
];
export const DRUG_FAMILY_DATA = [
  { name: 'Family Id', value: 'familyid' },
  { name: 'Drug Family Name', value: 'familyname' },
];
export const DRUG_FAMILY_TABLE_COLUMNS = [
  {
    headerName: 'Family Id',
    field: 'familySeqNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    filter: true,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellStyle: { borderRightColor: Styles.BorderColor },
  },
  {
    headerName: 'Drug Family Name',
    field: 'familyName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    filter: true,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellStyle: { borderRightColor: Styles.BorderColor },
  },
];
